var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 300,
    fill: "#009e49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 500,150 L 0,300 z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0,13.05 L 456,150 L 0,286.95 z",
    fill: "#fcd116"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 250,150 L 0,300 z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 0,17.5 L 220.85,150 L 0,282.5 z",
    fill: "#ce1126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGy);
export default __webpack_public_path__ + "static/media/gy.a1df57d3d2d8563516bc622a10db086f.svg";
export { ForwardRef as ReactComponent };